import _ from "lodash";
export const getRoundedDecimalValue = value => {
  // round off to 5 decimals to compensate floating point error, e.g. 0.1 + 0.2 = 0.30000000000000004
  // and round off to 2 decimals because we use 2 decimal places
  return _.round(_.round(value, 5), 2);
};
